<template>
  <main v-if="progress" class="founder-journey mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Founder Journey</h1>
    </div>
    <div v-show="progress.stage_one === 'New'">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class="mr-16 mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">Data Request</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Prior to our first call please fill out this questionnaire</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Click on the save draft button to save your progress</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">5mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
        <div class="flex flex-col flex-grow lg:pb-10 pb-8">
          <div class="max-w-[613px]">
            <div class="contain">
              <!-- <div v-show="windowWidth > 768" class="progress-bar relative">
                <div class="line w-[87%] bg-lineGray h-[2px] absolute mx-3 left-7 top-[7.5px]"></div>
                <div class="step flex flex-col items-center">
                  <div class="bullet active">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Team & Impact</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Market</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Operations</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Fundraise</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Schedule Meeting time</p>
                </div>
              </div> -->
              <div class="progress relative bg-faintGrey rounded-[4px] py-3 px-4 mb-8">
                <div class="current-progress relative flex items-center justify-between active">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Team and Impact
                  </div>
                  <div class="max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="text-black">1</span> of 5
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Market
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">2</span> of 5
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Operations
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">3</span> of 5
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Fundraise
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">4</span> of 5
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Schedule Meeting
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">5</span> of 5
                  </div>
                </div>
              </div>
              <div>
                <div class="form-outer">
                  <div class="forms">
                    <div class="page slide-page">
                      <div class="relative w-full mb-6">
                        <label
                          class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                          for="keyTeam"
                        >
                          <span class="text-red-400">*</span>
                          Who are the founders and key team members?
                        </label>
                        <div v-for="(member, index) in data.key_team" :key="index" class="flex flex-col">
                          <div class="grid md:grid-cols-2 grid-cols-1 gap-2 mb-2">
                            <div class="name md:mr-2 mr-0">
                              <label
                                class="font-Rubik text-greyText text-[11px] leading-[13.04px] font-normal"
                                for="suggestions"
                              >
                                <!-- <span class="text-red-400">*</span> -->
                                FULL NAME
                              </label>
                              <input
                                v-model="v$.key_team.$model[index].name"
                                id="keyTeam"
                                name="keyTeam"
                                type="text"
                                :class="[
                                (v$.key_team.$each.$response.$data[index].name.$error && v$.key_team.$dirty) ? 'border-red-400' : 'border-grey-300'
                                ]"
                                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                placeholder="Full Name"
                                style="transition: 'all .15s ease'"
                                @blur="v$.key_team.$touch()"
                              />
                              <div v-if="v$.key_team.$each.$response.$data[index].name.$error && v$.key_team.$dirty">
                                <p
                                  v-if="!v$.key_team.$each.$response.$data[index].name.required"
                                  class="text-red-400 text-[10px] font-light"
                                >Name is required</p>
                                <p
                                  v-if="!v$.key_team.$each.$response.$data[index].name.alpha"
                                  class="text-red-400 text-[10px] font-light"
                                >Full name should contain first and last name</p>
                                <!-- {{v$.key_team.$each.$response.$data[index].name}} -->
                                <!-- <p
                                  v-if="v$.key_team.$each.$response.$data[index].name.minLengthValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Team member name should be at least 3 characters long</p> -->
                              </div>
                            </div>
                            <div class="role">
                              <label
                                class="font-Rubik text-greyText text-[11px] leading-[13.04px] font-normal"
                                for="suggestions"
                              >
                                <!-- <span class="text-red-400">*</span> -->
                                ROLE
                              </label>

                              <div class="relative">
                                <span v-if="index > 0" @click="removeField(data.key_team, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2 h-[max-content] transform translate-y-[15px]">
                                  <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                  </svg>
                                </span>
                                <input
                                  v-model="v$.key_team.$model[index].role"
                                  id="keyTeamRole"
                                  name="keyTeamRole"
                                  type="text"
                                  :class="[
                                  (v$.key_team.$each.$response.$data[index].role.$error && v$.key_team.$dirty) ? 'border-red-400' : 'border-grey-300'
                                  ]"
                                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                  placeholder="Role"
                                  style="transition: 'all .15s ease'"
                                  @blur="v$.key_team.$touch()"
                                />
                                <div v-if="v$.key_team.$each.$response.$data[index].role.$error && v$.key_team.$dirty">
                                  <p
                                    v-if="!v$.key_team.$each.$response.$data[index].role.$required && v$.key_team.$each.$response.$data[index].role.minLengthValue"
                                    class="text-red-400 text-[10px] font-light"
                                  >Role is required</p>
                                  <p
                                  v-if="!v$.key_team.$each.$response.$data[index].role.minLengthValue"
                                    class="text-red-400 text-[10px] font-light"
                                  >Role should be at least 3 characters long</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="addNewField(data.key_team)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another team member</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                          for="motivation"
                        >
                          <span class="text-red-400">*</span>
                          What motivates you as founders
                        </label>
                        <textarea
                          id="motivation"
                          name="motivation"
                          type="text"
                          rows="3"
                          :class="[
                          v$.motivation.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Tell us briefly why you became an entrepreneur, the goals you have, and what excites you about this current role."
                          style="transition: 'all .15s ease'"
                          v-model="v$.motivation.$model"
                          @blur="v$.motivation.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.motivation.length} of 250`}}</span>
                        <div v-if="v$.motivation.$error">
                          <p
                            v-if="v$.motivation.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Motivation is required</p>
                          <p
                            v-if="v$.motivation.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Motivation should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                          for="positiveImpact"
                        >
                          <span class="text-red-400">*</span>
                          Describe the Positive Impact Your Organization Has on Its Stakeholders
                        </label>
                        <textarea
                          id="positiveImpact"
                          name="positiveImpact"
                          type="text"
                          rows="3"
                          :class="[
                          v$.positive_impact.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder=" How does your company improve the wellbeing of your clients, your community, and ultimately the world"
                          style="transition: 'all .15s ease'"
                          v-model="v$.positive_impact.$model"
                          @blur="v$.positive_impact.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.positive_impact.length} of 250`}}</span>
                        <div v-if="v$.positive_impact.$error">
                          <p
                            v-if="v$.positive_impact.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Positive impact is required</p>
                          <p
                            v-if="v$.positive_impact.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Motivation should be at least 3 characters long</p>
                        </div>
                      </div>
                      <!-- <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="impactMeasurement"
                        >
                          <span class="text-red-400">*</span>
                          How do you currently or intend on measuring impact?
                        </label>
                        <textarea
                          id="impactMeasurement"
                          name="impactMeasurement"
                          type="text"
                          rows="3"
                          :class="[
                          v$.impact_measurement.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="As a company that’s driving an increasing number of fashion lovers to switch from buying to renting..."
                          style="transition: 'all .15s ease'"
                          v-model="v$.impact_measurement.$model"
                          @blur="v$.impact_measurement.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.impact_measurement.length} of 100`}}</span>

                        <div v-if="v$.impact_measurement.$error">
                          <p
                            v-if="v$.impact_measurement.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Impact measurement is required</p>
                        </div>
                      </div> -->
                      <!-- <div class="relative w-full mb-28">
                        <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                          <span class="text-red-400">*</span>
                          Are you open to formalized, transparent impact metrics such as B-Analytics?</label>
                        <fieldset class="mt-4">
                          <legend class="sr-only">
                            Are you open to formalized, transparent impact metrics such as B-Analytics?</legend>
                          <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                            <div class="flex items-center ml-2">
                              <input id="yes" name="impact_metrics" value="Yes" type="radio" v-model="data.impact_metrics" checked class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600">
                              <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                                Yes
                              </label>
                            </div>

                            <div class="flex items-center">
                              <input id="no" name="impact_metrics" value="No" type="radio" v-model="data.impact_metrics" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600">
                              <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                                No
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div> -->
                      <div class="relative flex md:justify-end justify-between w-full mb-6">
                        <button
                          class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
                          @click="onSaveDraft"
                        >
                          Save draft
                        </button>
                        <button :disabled="checkValidForm(v$, 'Team and Impact')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] md:max-w-[118px] w-full outline-none focus:outline-none disabled:opacity-50" @click="goToStep2">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="targetMarket"
                        >
                          <span class="text-red-400">*</span>
                          What is the target market of the firm?
                        </label>
                        <textarea
                          id="targetMarket"
                          name="targetMarket"
                          type="text"
                          rows="3"
                          :class="[
                          v$.target_market.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us who are you are providing your product/service/platform to, and how big is this total addressable market"
                          style="transition: 'all .15s ease'"
                          v-model="v$.target_market.$model"
                          @blur="v$.target_market.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.target_market.length} of 100`}}</span>

                        <div v-if="v$.target_market.$error">
                          <p
                            v-if="v$.target_market.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Target market is required</p>
                          <p
                            v-if="v$.target_market.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Target market should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="problemSolving"
                        >
                          <span class="text-red-400">*</span>
                          What problem are you trying to solve?
                        </label>
                        <textarea
                          id="problemSolving"
                          name="problemSolving"
                          type="text"
                          rows="3"
                          :class="[
                          v$.solution.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us why your solution matters and how it changes the behavior of the end-users within your market."
                          style="transition: 'all .15s ease'"
                          v-model="v$.solution.$model"
                          @blur="v$.solution.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.solution.length} of 100`}}</span>

                        <div v-if="v$.solution.$error">
                          <p
                            v-if="v$.solution.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Problem solving is required</p>
                          <p
                            v-if="v$.solution.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Problem solving should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="valueProposition"
                        >
                          <span class="text-red-400">*</span>
                          What is the company's value proposition?
                        </label>
                        <textarea
                          id="valueProposition"
                          name="valueProposition"
                          type="text"
                          rows="3"
                          :class="[
                          v$.value_proposition.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us why a customer should choose your product or solution, and what is the ultimate benefit they receive by working with you"
                          style="transition: 'all .15s ease'"
                          v-model="v$.value_proposition.$model"
                          @blur="v$.value_proposition.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.value_proposition.length} of 100`}}</span>

                        <div v-if="v$.value_proposition.$error">
                          <p
                            v-if="v$.value_proposition.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Value proposition is required</p>
                          <p
                            v-if="v$.value_proposition.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Value proposition should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="buyersDemographic"
                        >
                          <span class="text-red-400">*</span>
                          Who is your target customer?
                        </label>
                        <textarea
                          id="buyersDemographic"
                          name="buyersDemographic"
                          type="text"
                          rows="3"
                          :class="[
                          v$.customer_demographic.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us more about the person you've identified as most likely to purchase your products. (Age, gender, location, income, etc)"
                          style="transition: 'all .15s ease'"
                          v-model="v$.customer_demographic.$model"
                          @blur="v$.customer_demographic.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.customer_demographic.length} of 100`}}</span>

                        <div v-if="v$.customer_demographic.$error">
                          <p
                            v-if="v$.customer_demographic.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Buyer demographics is required</p>
                          <p
                            v-if="v$.customer_demographic.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Buyer demographics should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="observedCharacteristics"
                        >
                          <span class="text-red-400">*</span>
                          What are some patterns you’ve observed of your target customers?
                        </label>
                        <textarea
                          id="observedCharacteristics"
                          name="observedCharacteristics"
                          type="text"
                          rows="3"
                          :class="[
                          v$.customer_character.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us more about when, how, and why your target customers are likely to use your product or service. (eg. Time of Day of Use, Web/Mobile/Offline Usage, etc)"
                          style="transition: 'all .15s ease'"
                          v-model="v$.customer_character.$model"
                          @blur="v$.customer_character.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.customer_character.length} of 250`}}</span>

                        <div v-if="v$.customer_character.$error">
                          <p
                            v-if="v$.customer_character.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Observed characteristics is required</p>
                          <p
                            v-if="v$.customer_character.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Observed characteristics should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="secondaryMarkets"
                        >
                          <span class="text-red-400">*</span>
                        What are the company’s secondary target markets?
                        </label>
                        <textarea
                          id="secondaryMarkets"
                          name="secondaryMarkets"
                          type="text"
                          rows="3"
                          :class="[
                          v$.secondary_markets.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us more about the group of people who are the second most likely to purchase your products and services"
                          style="transition: 'all .15s ease'"
                          v-model="v$.secondary_markets.$model"
                          @blur="v$.secondary_markets.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.secondary_markets.length} of 100`}}</span>

                        <div v-if="v$.secondary_markets.$error">
                          <p
                            v-if="v$.secondary_markets.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Secondary markets is required</p>
                          <p
                            v-if="v$.secondary_markets.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Secondary markets should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="competitiors"
                        >
                          <span class="text-red-400">*</span>
                        Who are the firm’s main competitors
                        </label>
                        <textarea
                          id="competitiors"
                          name="competitors"
                          type="text"
                          rows="3"
                          :class="[
                          v$.competitors.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us briefly about the companies that offer similar or identical products and services to your own"
                          style="transition: 'all .15s ease'"
                          v-model="v$.competitors.$model"
                          @blur="v$.competitors.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.competitors.length} of 100`}}</span>

                        <div v-if="v$.competitors.$error">
                          <p
                            v-if="v$.competitors.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Competitors is required</p>
                          <p
                            v-if="v$.competitors.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Competitors should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="market_barriers"
                        >
                          <span class="text-red-400">*</span>
                          What are the current barriers to entry in this market?
                        </label>
                        <textarea
                          id="market_barriers"
                          name="market_barriers"
                          type="text"
                          rows="3"
                          :class="[
                          v$.market_barriers.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us more about what makes it difficult for new firms to enter your market"
                          style="transition: 'all .15s ease'"
                          v-model="v$.market_barriers.$model"
                          @blur="v$.market_barriers.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.competitors.length} of 400`}}</span>

                        <div v-if="v$.market_barriers.$error">
                          <p
                            v-if="v$.market_barriers.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Market barriers is required</p>
                          <p
                            v-if="v$.market_barriers.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Market barriers should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep1">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Market')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep1">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Market')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="revenueModel"
                        >
                          <span class="text-red-400">*</span>
                          What is your revenue model?
                        </label>
                        <textarea
                          id="revenueModel"
                          name="revenueModel"
                          type="text"
                          rows="3"
                          :class="[
                          v$.revenue_model.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us how you are currently or intend to make money for your product/service"
                          style="transition: 'all .15s ease'"
                          v-model="v$.revenue_model.$model"
                          @blur="v$.revenue_model.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.revenue_model.length} of 100`}}</span>

                        <div v-if="v$.revenue_model.$error">
                          <p
                            v-if="v$.revenue_model.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Revenue model is required</p>
                          <p
                            v-if="v$.revenue_model.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Revenue model should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="earlyTraction"
                        >
                          <span class="text-red-400">*</span>
                          What early traction do you have?
                        </label>
                        <textarea
                          id="earlyTraction"
                          name="earlyTraction"
                          type="text"
                          rows="3"
                          :class="[
                          v$.early_traction.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us how many of your current or potential customers have expressed an interest in your product or service"
                          style="transition: 'all .15s ease'"
                          v-model="v$.early_traction.$model"
                          @blur="v$.early_traction.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.early_traction.length} of 100`}}</span>

                        <div v-if="v$.early_traction.$error">
                          <p
                            v-if="v$.early_traction.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Early traction is required</p>
                          <p
                            v-if="v$.early_traction.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Early traction should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="tractionReason"
                        >
                          <span class="text-red-400">*</span>
                          What is the reason for the traction?
                        </label>
                        <textarea
                          id="tractionReason"
                          name="tractionReason"
                          type="text"
                          rows="3"
                          :class="[
                          v$.traction_reason.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="100"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Please tell us how your current or potential customers have been able to find your product or service"
                          style="transition: 'all .15s ease'"
                          v-model="v$.traction_reason.$model"
                          @blur="v$.traction_reason.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.traction_reason.length} of 100`}}</span>

                        <div v-if="v$.traction_reason.$error">
                          <p
                            v-if="v$.traction_reason.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Traction reason is required</p>
                          <p
                            v-if="v$.traction_reason.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Traction reason should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="burnRate"
                        >
                          <span class="text-red-400">*</span>
                          What is your net cash burn per month in USD?
                        </label>
                        <input
                          id="burnRate"
                          name="burnRate"
                          type="number"
                          :class="[
                          v$.burn_rate.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          min="0"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Kindly tell us your monthly net cash burn"
                          style="transition: 'all .15s ease'"
                          v-model="v$.burn_rate.$model"
                          @blur="v$.burn_rate.$touch()"
                        />
                        <div v-if="v$.burn_rate.$error">
                          <p
                            v-if="v$.burn_rate.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Burn rate is required</p>
                          <p
                            v-if="v$.burn_rate.minValueValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >{{v$.burn_rate.minValueValue.$message}}</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="keyPerformance"
                        >
                          <span class="text-red-400">*</span>
                          What are the key performance indicators (KPIs) you are focused on currently?
                        </label>

                        <div class="relative" v-for="(kpi, index) in data.performance_indicators" :key="index">
                          <span v-if="index > 0" @click="removeField(data.performance_indicators, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2 h-[max-content] transform translate-y-[15px]">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                          <input
                            id="keyPerformance"
                            name="keyPerformance"
                            type="text"
                            :class="[
                            (v$.performance_indicators.$each.$response.$data[index].data.$error && v$.performance_indicators.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="(e.g. Monthly Active Users, New Customer Sign Ups)"
                            style="transition: 'all .15s ease'"
                            v-model="v$.performance_indicators.$model[index].data"
                            @blur="v$.performance_indicators.$touch()"
                          />
                          <div v-if="v$.performance_indicators.$each.$response.$data[index].data.$error && v$.performance_indicators.$dirty">
                            <p
                              v-if="v$.performance_indicators.$each.$response.$data[index].data.$invalid && v$.performance_indicators.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Key performance is required</p>
                            <p
                              v-if="v$.performance_indicators.$each.$response.$data[index].data.$invalid && !v$.performance_indicators.$each.$response.$data[index].data.minLengthValue"
                                class="text-red-400 text-[10px] font-light"
                              >Key performance should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addDataField(data.performance_indicators)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep2">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Operations')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep4">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[16px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep2">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Operations')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep4">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="useOfCash"
                        >
                          <span class="text-red-400">*</span>
                          What will be the uses of cash for this current round of fundraising?
                        </label>

                        <div v-for="(useOfCash, index) in data.cash_use" :key="index" class="relative">
                          <span v-if="index > 0" @click="removeField(data.cash_use, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2 h-[max-content] transform translate-y-[15px]">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                            <input
                            id="useOfCash"
                            name="useOfCash"
                            type="text"
                            :class="[
                            (v$.cash_use.$each.$response.$data[index].data.$error && v$.cash_use.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="(e.g. Sales & Marketing, Technology Improvements)"
                            style="transition: 'all .15s ease'"
                            v-model="v$.cash_use.$model[index].data"
                            @blur="v$.cash_use.$touch()"
                          />
                          <div v-if="v$.cash_use.$each.$response.$data[index].data.$error && v$.cash_use.$dirty">
                            <p
                              v-if="v$.cash_use.$each.$response.$data[index].data.$invalid && v$.cash_use.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Cash use is required</p>
                            <p
                              v-if="v$.cash_use.$each.$response.$data[index].data.$invalid && !v$.cash_use.$each.$response.$data[index].data.minLengthValue"
                                class="text-red-400 text-[10px] font-light"
                              >Cash use should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addDataField(data.cash_use)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="milestones"
                        >
                          <span class="text-red-400">*</span>
                          What are the milestones that you are targeting?
                        </label>

                        <div class="relative" v-for="(milestone, index) in data.milestones" :key="index">
                          <span v-if="index > 0" @click="removeField(data.milestones, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2 h-[max-content] transform translate-y-[15px]">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                          <input
                            id="milestones"
                            name="milestones"
                            type="text"
                            :class="[
                            (v$.milestones.$each.$response.$data[index].data.$error && v$.milestones.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="(e.g. 25,000 Monthly Active Users in 6 months)"
                            style="transition: 'all .15s ease'"
                            v-model="v$.milestones.$model[index].data"
                            @blur="v$.milestones.$touch()"
                          />
                          <div v-if="v$.milestones.$each.$response.$data[index].data.$error && v$.milestones.$dirty">
                            <p
                              v-if="v$.milestones.$each.$response.$data[index].data.$invalid && v$.milestones.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Milestones is required</p>
                            <p
                              v-if="v$.milestones.$each.$response.$data[index].data.$invalid && !v$.milestones.$each.$response.$data[index].data.minLengthValue"
                                class="text-red-400 text-[10px] font-light"
                              >Milestones should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addDataField(data.milestones)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep3">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Fundraise')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep5">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded text-[14px] leading-[16px] font-Rubik px-[28px] py-[14px] w-full max-w-[50%] outline-none focus:outline-none mr-8" @click="returnToStep3">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center md:bg-[transparent] bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Fundraise')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep5">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="meetingTime"
                        >
                          <span class="text-red-400">*</span>
                          Schedule time to speak with the Kinfolk team
                        </label>
                        <div class="mt-4 flex items-center">
                          <Switch
                            v-model="enabled"
                            :disabled="calenderLoaded"
                            :class="enabled ? 'bg-black' : 'bg-lineGray'"
                            class="relative inline-flex flex-shrink-0 h-[31px] w-[51px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                          >
                            <span class="sr-only">Schedule meeting time</span>
                            <span
                              aria-hidden="true"
                              :class="enabled ? 'translate-x-5' : 'translate-x-0'"
                              class="pointer-events-none inline-block h-[27px] w-[27px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"
                            />
                          </Switch>
                          <p class="ml-4 text-black font-Rubik text-[15px] leading-[17.78px]">Schedule meeting time</p>
                        </div>
                      <svg v-if="enabled && !calenderLoaded" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="35px" height="35px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                          <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                          </circle>
                        </svg>
                        <div id="calender" class="h-[600px] mt-1">

                        </div>
                      </div>
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep4">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="!schedule_meeting" @click="onSubmit" class="flex bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50">
                            <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                            <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                              <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                              </circle>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded text-[14px] leading-[16px] font-Rubik px-[28px] py-[14px] w-full max-w-[50%] outline-none focus:outline-none mr-8" @click="returnToStep4">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="!schedule_meeting" @click="onSubmit" class="flex items-center justify-center bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50">
                          <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                          <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                            </circle>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_one === 'Processing'">
      <div class="flex items-center justify-center w-full min-h-[370px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_one ===  'Approved'" class="flex flex-col justify-between pt-4 pb-2 text-sm text-gray-500">
      <div class="my-[120px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { Switch } from '@headlessui/vue'
import industries from '@/utils/industries'
import businessmodel from '@/utils/businessmodels'
import fundinground from '@/utils/fundinground'
import fundingtype from '@/utils/fundingtype'
import useVuelidate from '@vuelidate/core'
import { required, url, helpers, minValue, minLength } from '@vuelidate/validators'
import { useStore } from 'vuex'
import Helpers from '@/utils/helpers'
import StageOneService from '@/services/stageone.service'
import DraftService from '@/services/draft.service'
import CompanyService from '@/services/company.service'
import store from '@/store'

const fetchCompany = async () => {
  try {
    const staleDisabled = {
      onboarding: false,
      stage_one: true,
      stage_two: true,
      stage_three: true,
      stage_four: true,
      stage_five: true,
      stage_six: true,
      stage_seven: true,
      stage_eight: true,
      feedback_survey: true
    }
    if (store.state.app.company) {
      const id = store.state.app.company.id
      const response = await CompanyService.fetchSingleCompany(id)
      if (response.status === 200 && response.data.status === 'success') {
        const disbaled = response.data.data.disabled
        // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
        return disbaled
      }
    } else return staleDisabled
  } catch (e) {
    return false
  }
}
const alpha = helpers.regex(/^[a-zA-Z]{2,}\s[a-zA-Z]{2,}$/)
export default {
  components: {
    Switch
  },
  async beforeRouteEnter (to, from) {
    // console.log(to.name)
    const response = await fetchCompany()
    if (!response) {
      return false
    }
    const answer = Helpers.getStageByDisabledName(to.name, response)
    store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
    if (answer.status) {
      return { name: 'Deligence' }
    }
  },
  setup () {
    let current = 2
    const route = useRoute()
    const store = useStore()
    const router = useRouter()

    const fetchCompanyData = async () => {
      try {
        const id = store.state.app.company.id
        const response = await CompanyService.fetchSingleCompany(id)
        if (response.status === 200 && response.data.status === 'success') {
          const disbaled = response.data.data.disabled
          // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
          return disbaled
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    onBeforeRouteLeave(async (to, from) => {
      if (to.name === 'SignIn' || to.name === 'Home' || to.name === 'Impact Assessment' || to.name === 'SDG Alignment' || to.name === 'Financial' || to.name === 'Integrations' || to.name === 'User Details') {
        return true
      }
      const response = await fetchCompanyData()
      if (!response) {
        return false
      }
      const answer = Helpers.getStageByDisabledName(to.name, response)
      store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
      if (answer.status) {
        return false
      }
    })

    const selectedIndustry = ref(industries[0])
    const selectedModel = ref(businessmodel[0])
    const selectedRound = ref(fundinground[0])
    const selectedType = ref(fundingtype[0])
    const typeRef = ref('')
    // const progress = reactive({
    //   stage1: true,
    //   stage2: false,
    //   stage3: true
    // })
    const disabled = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })

    const schedule_meeting = ref(false)
    const enabled = ref(false)
    const loading = ref(false)
    const calenderLoaded = ref(false)
    const windowWidth = ref(window.innerWidth)

    // const onWidthChange = () => {
    //   windowWidth.value = window.innerWidth
    // }
    // console.log(windowWidth.value)

    // onMounted(() => {
    //   window.addEventListener('resize', onWidthChange)
    // })
    // onUnmounted(() => {
    //   window.removeEventListener('resize', onWidthChange)
    // })

    const goToStep2 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-16.66%'
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep1 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '0%'
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep3 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.32%'
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep2 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-16.666%'
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep4 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-49.97%'
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep3 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.32%'
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep5 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-66.64%'
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep4 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-49.97%'
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    function isCalendlyEvent (e) {
      return e.data.event && e.data.event.indexOf('calendly') === 0
    }

    const getCalendar = () => {
      const name = store.state.app.company.company_name
      const email = store.state.auth.user.email
      // eslint-disable-next-line no-undef
      Calendly.initInlineWidget({
        url: process.env.VUE_APP_CALENDLY_URL,
        parentElement: document.getElementById('calender'),
        prefill: {
          name: name,
          email: email
        },
        utm: {}
      })
    }

    const getDraft = async () => {
      const id = store.state.app.company.id
      try {
        const response = await DraftService.getDraft(id, 'STAGE 1')
        if (response.status === 200 && response.data.status === 'success' && response.data.data !== null) {
          const draft = response.data.data
          data.key_team = draft.key_team
          data.motivation = draft.motivation
          data.positive_impact = draft.positive_impact
          data.impact_measurement = draft.impact_measurement
          data.impact_metrics = draft.impact_metrics
          data.target_market = draft.target_market
          data.solution = draft.solution
          data.value_proposition = draft.value_proposition
          data.customer_demographic = draft.customer_demographic
          data.customer_character = draft.customer_character
          data.secondary_markets = draft.secondary_markets
          data.competitors = draft.competitors
          data.market_barriers = draft.market_barriers
          data.revenue_model = draft.revenue_model
          data.early_traction = draft.early_traction
          data.traction_reason = draft.traction_reason
          data.burn_rate = draft.burn_rate
          data.performance_indicators = draft.performance_indicators
          data.cash_use = draft.cash_use
          data.milestones = draft.milestones
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    getDraft()

    // const submitloading = ref(false)
    const saveDraftLoading = ref(false)
    const onSaveDraft = async () => {
      saveDraftLoading.value = true
      const stagedata = {
        key_team: data.key_team,
        motivation: data.motivation,
        positive_impact: data.positive_impact,
        impact_measurement: data.impact_measurement,
        impact_metrics: data.impact_metrics,
        target_market: data.target_market,
        solution: data.solution,
        value_proposition: data.value_proposition,
        customer_demographic: data.customer_demographic,
        customer_character: data.customer_character,
        secondary_markets: data.secondary_markets,
        competitors: data.competitors,
        market_barriers: data.market_barriers,
        revenue_model: data.revenue_model,
        early_traction: data.early_traction,
        traction_reason: data.traction_reason,
        burn_rate: data.burn_rate,
        performance_indicators: data.performance_indicators,
        cash_use: data.cash_use,
        milestones: data.milestones
      }
      const draft = {
        company_id: company_id,
        stage: 'STAGE 1',
        data: stagedata
      }
      try {
        const response = await DraftService.saveDraft(draft)
        if (response.status === 200 && response.data.status === 'success') {
          const success = {
            status: true,
            message: 'Draft has been successfully saved',
            color: 'green',
            type: 'success'
          }
          store.dispatch('setAlert', success)
          setTimeout(() => {
            store.dispatch('setAlert', {
              status: false,
              message: null,
              color: null,
              type: null
            })
          }, 2000)
        }
      } catch (e) {
        saveDraftLoading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const data = reactive({
      key_team: [
        {
          name: '',
          role: ''
        }
      ],
      motivation: '',
      positive_impact: '',
      impact_measurement: 'N/A',
      impact_metrics: 'Yes',
      target_market: '',
      solution: '',
      value_proposition: '',
      customer_demographic: '',
      customer_character: '',
      secondary_markets: '',
      competitors: '',
      market_barriers: '',
      revenue_model: '',
      early_traction: '',
      traction_reason: '',
      burn_rate: '',
      performance_indicators: [
        {
          data: ''
        }
      ],
      cash_use: [
        {
          data: ''
        }
      ],
      milestones: [
        {
          data: ''
        }
      ]
    })

    const rules = computed(() => ({
      key_team: {
        $each: helpers.forEach({
          name: { required, minLengthValue: minLength(3), alpha },
          role: { required, minLengthValue: minLength(3) }
        })
      },
      motivation: { required, minLengthValue: minLength(3) },
      positive_impact: { required, minLengthValue: minLength(3) },
      // impact_measurement: { required },
      // impact_metrics: { required },
      target_market: { required, minLengthValue: minLength(3) },
      solution: { required, minLengthValue: minLength(3) },
      value_proposition: { required, minLengthValue: minLength(3) },
      customer_demographic: { required, minLengthValue: minLength(3) },
      customer_character: { required, minLengthValue: minLength(3) },
      secondary_markets: { required, minLengthValue: minLength(3) },
      competitors: { required, minLengthValue: minLength(3) },
      market_barriers: { required, minLengthValue: minLength(3) },
      revenue_model: { required, minLengthValue: minLength(3) },
      early_traction: { required, minLengthValue: minLength(3) },
      traction_reason: { required, minLengthValue: minLength(3) },
      burn_rate: {
        required,
        minValueValue: minValue(0)
      },
      performance_indicators: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      },
      cash_use: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      },
      milestones: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      }
    }))

    const v$ = useVuelidate(rules, data)

    const addNewField = (arr) => {
      arr.push({
        name: '',
        role: ''
      })
    }
    const addNewString = (refArr) => {
      refArr.push(typeRef.value)
    }
    const addDataField = (arr) => {
      arr.push({
        data: ''
      })
    }
    const removeField = (arr, index) => {
      arr.splice(index, 1)
    }
    const checkValidForm = (v$, screen) => {
      switch (screen) {
        case 'Team and Impact':
          if (v$.motivation.$invalid ||
          v$.positive_impact.$invalid ||
          // v$.impact_measurement.$invalid ||
          v$.key_team.$invalid) {
            return true
          }
          break
        case 'Market':
          if (v$.target_market.$invalid ||
          v$.solution.$invalid ||
          v$.value_proposition.$invalid ||
          v$.customer_demographic.$invalid ||
          v$.customer_character.$invalid ||
          v$.secondary_markets.$invalid ||
          v$.competitors.$invalid ||
          v$.market_barriers.$invalid) {
            return true
          }
          break
        case 'Operations':
          if (v$.revenue_model.$invalid ||
          v$.early_traction.$invalid ||
          v$.traction_reason.$invalid ||
          v$.burn_rate.$invalid ||
          v$.performance_indicators.$invalid) {
            return true
          }
          break
        case 'Fundraise':
          if (v$.cash_use.$invalid ||
          v$.milestones.$invalid) {
            return true
          }
          break
        default:
          return false
      }
    }
    const user_id = store.state.auth.user.id
    const company_id = store.state.app.company.id
    const onSubmit = async () => {
      loading.value = true
      const performanceIndicators = Helpers.changeToArray(data.performance_indicators, 'data')
      const cashUse = Helpers.changeToArray(data.cash_use, 'data')
      const mileStones = Helpers.changeToArray(data.milestones, 'data')
      // eslint-disable-next-line no-unused-vars
      const stagedata = {
        user_id: user_id,
        company_id: company_id,
        founders: data.key_team,
        motivation: data.motivation,
        positive_impact: data.positive_impact,
        impact_measurement: data.impact_measurement,
        impact_metrics: data.impact_metrics,
        target_market: data.target_market,
        solution: data.solution,
        value_proposition: data.value_proposition,
        customer_demographic: data.customer_demographic,
        customer_character: data.customer_character,
        secondary_market: data.secondary_markets,
        competitors: data.competitors,
        market_barriers: data.market_barriers,
        revenue_model: data.revenue_model,
        early_traction: data.early_traction,
        traction_reason: data.traction_reason,
        burn_rate: data.burn_rate,
        performance_indicators: performanceIndicators,
        cash_use: cashUse,
        milestones: mileStones
      }
      try {
        const response = await StageOneService.createStageOne(stagedata)
        if (response.status === 200 && response.data.status === 'success') {
          loading.value = false
          const success = {
            status: true,
            message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
          }
          store.commit('setSuccess', success)

          store.commit('setCompany', response.data.data.company)
          store.commit('setProgress', response.data.data.progress)
        }
      } catch (e) {
        loading.value = false
        Helpers.processError(e, store, router)
      }
    }

    onMounted(() => {
      window.addEventListener(
        'message',
        function (e) {
          if (isCalendlyEvent(e)) {
            if (e.data.event === 'calendly.event_scheduled') {
              schedule_meeting.value = true
              const calendar = document.getElementById('calender')
              calendar.style.display = 'none'
            } else if (e.data.event === 'calendly.event_type_viewed') {
              calenderLoaded.value = true
            } else {
              calenderLoaded.value = false
              schedule_meeting.value = false
            }
          }
        }
      )
    })

    watch(
      () => enabled.value,
      (value) => {
        if (value === true) {
          getCalendar()
        }
      }
    )

    return {
      progress: computed(() => store.state.app.progress_status),
      disabled,
      industries,
      selectedIndustry,
      businessmodel,
      selectedModel,
      fundinground,
      selectedRound,
      fundingtype,
      selectedType,
      goToStep2,
      returnToStep1,
      goToStep3,
      returnToStep2,
      goToStep4,
      returnToStep3,
      goToStep5,
      returnToStep4,
      enabled,
      v$,
      url,
      data,
      addNewField,
      addDataField,
      removeField,
      typeRef,
      addNewString,
      checkValidForm,
      onSubmit,
      loading,
      getCalendar,
      schedule_meeting,
      calenderLoaded,
      useRoute,
      route,
      windowWidth,
      current,
      onSaveDraft
    }
  }
}
</script>

<style scoped>
.contain .form-outer{
  width: 100%;
  overflow: hidden;
}
.contain .form-outer .forms{
  display: flex;
  width: 600%;
}
.form-outer .forms .page{
  width: 16.66%;
  transition: margin-left 0.3s ease-in-out;
}
.contain .progress-bar{
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 60px 5px;
  user-select: none;
}
.contain .progress-bar .step{
  text-align: center;
  position: relative;
}

.progress-bar .step .bullet{
  height: 16px;
  width: 16px;
  background-color: rgba(229, 230, 230, 1);
  display: flex;
  border-radius: 50%;
  position: relative;
  transition: 0.2s;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  z-index: 100;
  justify-content: center;
  align-items: center;
}

.progress-bar .step .bullet.active{
  background-color: #000000;
  height: 20px;
  width: 20px;
}
.progress-bar .step .bullet.active + p{
  color: #000000;
}
.progress-bar .step .bullet.active::after {
  content: "";
  height: 18px;
  width: 18px;
  background-color: transparent;
  border: solid 1px white;
  border-radius: 50%;
  position: absolute;
}
.progress .current-progress{
  display: none;
}
.progress .current-progress.active{
  display: flex;
}
</style>
